(function(){
    'use strict';

    angular.module('elogbooks.helpdesk.dashboard', []);
})();
